import { slugs } from '@/constants/slugs'

/**
 * Mapping of project slugs to their Guild highlight theme pills.
 * Used by the `guild-highlight-pills` experiment on the watch project page.
 */
export const GUILD_HIGHLIGHT_THEMES: Record<string, string[]> = {
  [slugs.tuttleTwins]: ['Liberty', 'Family', 'Truth'],
  [slugs.promisedLandSeries]: ['Faith', 'Perseverance', 'Humor'],
  [slugs.homesteadSeries]: ['Perseverance', 'Family', 'Faith'],
  [slugs.wingfeatherSaga]: ['Courage', 'Family', 'Hope'],
  [slugs.wayfinders]: ['Courage', 'Identity', 'Community'],
  [slugs.jungleBeat]: ['Joy', 'Kindness', 'Community'],
  [slugs.testamentSeries]: ['Faith', 'Hope', 'Family'],
  [slugs.youngDavid]: ['Faith', 'Courage', 'Purpose'],
  [slugs.miracle]: ['Hope', 'Healing', 'Faith'],
  [slugs.riotAndTheDanceSeries]: ['Wonder', 'Faith', 'Creation'],
  [slugs.soloMio]: ['Redemption', 'Humor', 'Healing'],
  [slugs.david]: ['Faith', 'Courage', 'Hope'],
  [slugs.stillHope]: ['Hope', 'Healing', 'Family'],
  [slugs.tenLives]: ['Kindness', 'Courage', 'Redemption'],
  [slugs.kingOfKings]: ['Faith', 'Love', 'Sacrifice'],
  [slugs.homestead]: ['Perseverance', 'Family', 'Faith'],
  [slugs.hailMary]: ['Faith', 'Compassion', 'Wisdom'],
  [slugs.theLastRodeo]: ['Family', 'Sacrifice', 'Hope'],
  [slugs.dragonsProphecy]: ['Faith', 'Courage', 'Justice'],
  [slugs.iWasAStranger]: ['Compassion', 'Courage', 'Redemption'],
  [slugs.quincyCarrImHumanIChecked]: ['Humor', 'Family', 'Joy'],
  [slugs.johnBranyanUncommonCore]: ['Humor', 'Family', 'Wisdom'],
  [slugs.shayneSmithKangarooKiller]: ['Humor', 'Liberty', 'Perseverance'],
  [slugs.robSchneiderIReallyLoveYou]: ['Humor', 'Love', 'Joy'],
  [slugs.patrickWarburtonStillCatholic]: ['Humor', 'Faith', 'Family'],
}

/**
 * Returns the highlight themes for a project slug, or undefined if not in the experiment.
 */
export const getGuildHighlightThemes = (slug: string): string[] | undefined => {
  return GUILD_HIGHLIGHT_THEMES[slug]
}
